export default __webpack_public_path__ + "static/media/Group 1171276208 (2).67af7fce.svg";